import { useReducer } from 'react';
import { createReducer, IPaginationState } from 'src/utils/server-side-pagination';
import { useGetSubscriptionsQuery } from 'src/store/slices/webhooksAPISlice';
import { useHasPermission } from 'src/lib/hooks/useHasPermission';
import { Permission } from 'src/assets/data/permissions';

export const ROWS_PER_PAGE = 10;

export const initialState: IPaginationState = {
  filters: {},
  sorting: {},
  page: 1,
};

export const useGetPaginatedSubscriptions = () => {
  const canRead = useHasPermission(Permission.ReadWebhooks);
  const [state, dispatch] = useReducer(createReducer(initialState), initialState);

  const { data, isLoading, isFetching } = useGetSubscriptionsQuery(
    { state, limit: ROWS_PER_PAGE },
    { refetchOnMountOrArgChange: true, skip: !canRead }
  );

  return {
    data: data?.data ?? [],
    totalPages: data?.totalPages,
    totalItems: data?.totalItems,
    paginationPage: data?.page,
    isLoading,
    isFetching,
    ...state,
    dispatch,
  };
};
